import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { EmailComposeProvider } from "@/context/EmailComposeContext";
import SiteLayout from "@/components/SiteLayout";
import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import Servizi from "@/pages/Servizi";
import Poliurea from "@/pages/Poliurea";
import Poliuretano from "@/pages/Poliuretano";
import Fotovoltaico from "@/pages/Fotovoltaico";
import ParetiVentilate from "@/pages/ParetiVentilate";
import RivestimentiPiscine from "@/pages/RivestimentiPiscine";
import RivestimentiProtettivi from "@/pages/RivestimentiProtettivi";
import RestauroConservativo from "@/pages/RestauroConservativo";
import Ristrutturazioni from "@/pages/Ristrutturazioni";
import Finiture from "@/pages/Finiture";
import Progetti from "@/pages/Progetti";
import ProjectDetail from "@/pages/ProjectDetail";
import Contatti from "@/pages/Contatti";
import Privacy from "@/pages/Privacy";
import Preventivo from "@/pages/Preventivo";
import LavoraConNoi from "@/pages/LavoraConNoi";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ProtectedRoute from "@/pages/admin/ProtectedRoute";
import IntroExperience from "@/components/IntroExperience";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <EmailComposeProvider>
          <BrowserRouter>
          <IntroExperience />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/chi-siamo" element={<ChiSiamo />} />
              <Route path="/servizi" element={<Servizi />} />
              <Route path="/impermeabilizzazione-poliurea" element={<Poliurea />} />
              <Route path="/coibentazione-poliuretano" element={<Poliuretano />} />
              <Route path="/efficientamento-energetico" element={<Fotovoltaico />} />
              <Route path="/pareti-ventilate" element={<ParetiVentilate />} />
              <Route path="/rivestimenti-piscine" element={<RivestimentiPiscine />} />
              <Route path="/rivestimenti-protettivi" element={<RivestimentiProtettivi />} />
              <Route path="/restauro-conservativo" element={<RestauroConservativo />} />
              <Route path="/ristrutturazioni-chiavi-in-mano" element={<Ristrutturazioni />} />
              <Route path="/finiture-e-rivestimenti" element={<Finiture />} />
              <Route path="/progetti" element={<Progetti />} />
              <Route path="/progetti/:slug" element={<ProjectDetail />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/preventivo" element={<Preventivo />} />
              <Route path="/lavora-con-noi" element={<LavoraConNoi />} />
              <Route path="/privacy" element={<Privacy />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
        </EmailComposeProvider>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
